import React from 'react';
import HeaderIcon from '@rsmus/rsm-catt-ui/dist/components/header/headerIcon';
import HeaderUser from './HeaderUser';
import appLogo from 'cui/assets/images/insight-icon.svg';
import { Link } from 'react-router-dom';
import { User } from 'oidc-client-ts';

interface HeaderProps {
    appTitle?: string;
    userActionList?: any[];
    user?: User;
    logout: () => void;
    dynamicComponents?: React.ComponentType<any>[];
}

export const Header: React.FC<HeaderProps> = ({ appTitle, userActionList, user, logout, dynamicComponents }) => {
    const userActionLinks = userActionList ? userActionList : [];

    const getUserInitials = (): string => {
        const userName = user?.profile?.name;
        const capitalize = userName?.match(/\b(\w)/g);
        const initials = capitalize?.join('');
        return initials ? initials : '';
    };

    const appInfo:any  = {
        app: "In",
        logo: appLogo,
        xp: "Sight"
    }

    return (
        <>
            <div className="cui-header">
                <Link to='/'>
                    {appTitle ? <HeaderIcon appTitle={appInfo} /> : null}
                </Link>
                <div className="page-header_meta">
                    <div className="page-header_meta-actions">
                        {dynamicComponents && dynamicComponents.map((Component, index) => (
                            <Component key={index} />
                        ))}
                    </div>
                    <HeaderUser 
                        user={getUserInitials()}
                        userActionLinks={userActionLinks}
                        logout={logout} 
                    />
                </div>
            </div>
        </>
    );
};